export default class EventMessageCtrl {
    constructor($scope, $q, $filter, $rootScope, $timeout, $state, $stateParams, $window, Tag, Rest, SweetAlert, Segment, SideMenu, Campaign, Automation, Events, Event, Setting) {
        SideMenu.setActive('event');

        this._scope = $scope;
        this._rootScope = $rootScope;
        this._stateParams = $stateParams;
        this._q = $q;
        this._translator = $filter('translate');
        this._state = $state;
        this._timeout = $timeout;
        this._window = $window;

        this.eventRepo = Event;
        this.campaignRepo = Campaign;
        this.tagRepo = Tag;
        this.automationRepo = Automation;
        this.segmentRepo = Segment;
        this.settingRepo = Setting;
        this.eventHandler = Events;
        this.alerter = SweetAlert;
        this.rest = Rest.rest;

        this.dispatcherType = this._stateParams.type;
        this.hasBeenEdited = false;
        this.imageBankVisible = false;
        this.statusIdToNameMap = {
            1: 'draft',
            2: 'current',
            3: 'completed',
            4: 'scheduled',
            5: 'cancelled'
        };

        this.preview = {
            to: this._window.localStorage.getItem('preview_to') ? this._window.localStorage.getItem('preview_to') : null
        };

        this.eventRepo.find(this._stateParams.eventId).then((event) => {
            this.event = event.data;
            let collection = this._stateParams.type == 'campaign' ? this.event.campaigns : this.event.automations;

            angular.forEach(collection, (item) => {
                if (item['id'] == $stateParams.dispatcherId) {
                    this.hasBeenEdited = item['pivot']['edited'] == 1;
                }
            });
        });

        this.tagRepo.all().then((result) => {
            this.activeTags = result.data;
            this._scope.$broadcast('mailEditor:tags:fetched', this.activeTags);
        });

        this.segmentRepo.all().then((result) => {
            this.activeSegments = result.data;
            this._scope.$broadcast('mailEditor:segments:fetched', this.activeSegments);
        });

        this.init();
    }

    toggleImageBank() {
        this.imageBankVisible = ! this.imageBankVisible;
        this._scope.$emit('imageBank:toggle');
    }

    init() {
        if (this._stateParams.type == 'campaign') {
            this.campaignRepo.find(this._stateParams.dispatcherId).then((campaign) => {
                this.dispatcher = campaign.data;
                this.dispatcher.email = campaign.data.email.data;
                //this._scope.$broadcast('mailEditor:fetchTemplate', { templateId: this.dispatcher.email.email_template_id });

                this.dispatcher.message_type = 'email';
                this.htmlSource = "campaign/" + this._stateParams.dispatcherId + "/emailContent";
                this.plainSource = "campaign/" + this._stateParams.dispatcherId + "/emailContent";
                this._scope.$broadcast('mailEditor:state:init', {
                    dispatcher: this.dispatcher,
                    dispatcherType: 'campaign',
                    htmlSource: this.htmlSource,
                    plainSource: this.plainSource,
                    templateId: this.dispatcher.email.email_template_id
                });
            });
        } else if (this._stateParams.type == 'automation') {
            this.automationRepo.findEmail(this._stateParams.dispatcherId, this._stateParams.emailId).then((email) => {
                this.dispatcher = { email: email.data };
                this.htmlSource = "automail/" + this._stateParams.dispatcherId + "/email/" + this._stateParams.emailId + "/htmlContent";
                this.plainSource = "automail/" + this._stateParams.dispatcherId + "/email/" + this._stateParams.emailId + "/plainContent";

                this._scope.$broadcast('mailEditor:state:init', {
                    dispatcher: this.dispatcher,
                    dispatcherType: 'automation',
                    htmlSource: this.htmlSource,
                    plainSource: this.plainSource,
                    templateId: this.dispatcher.email.email_template_id
                });
            });
        }
    };

    static hasContent(htmlContent) {
        return $(new DOMParser().parseFromString(htmlContent, "text/html")).find("body").children().length > 0;
    };

    flashElement(element, numIterations) {
        this._timeout(() => {
            $(element).toggleClass('red-border');

            if (numIterations > 0) {
                this.flashElement(element, numIterations - 1);
            }
        }, 1000);
    };

    handleSaveError(errorCode) {
        if (errorCode == 1) {
            this.eventHandler.flashEvent('error', this._filter('translate')('CAMPAIGN:FLASH:MISSING_SENDER_EMAIL'));

            this._timeout(() => {
                var inputElement = $('#sender-email').first();
                inputElement.focus();
                this.flashElement(inputElement, 7);
            });
        } else if (errorCode == 2) {
            this.eventHandler.flashEvent('error', this._filter('translate')('CAMPAIGN:FLASH:MISSING_SENDER_NAME'));

            this._timeout(() => {
                var inputElement = $('#sender-name').first();
                inputElement.focus();
                this.flashElement(inputElement, 7);
            });
        } else {
            this.eventHandler.flashEvent('error', this._filter('translate')('CAMPAIGN:FLASH:UPDATE_ERROR'));
        }
    };

    save() {
        let htmlContent, plainContent;
        let deferred = this._q.defer();

        this._scope.$broadcast('mailEditor:prepareHtml', (content) => {
            htmlContent = content;
        });

        this._scope.$broadcast('plainEditor:getContent', (plain) => {
            plainContent = plain;
        });

        if (this.dispatcherType == 'campaign') {
            this.dispatcher.email.htmlContent = htmlContent;
            this.dispatcher.email.plainContent = plainContent;
        } else {
            this.dispatcher.email.html_content = htmlContent;
            this.dispatcher.email.plain_content = plainContent;
        }

        this.dispatcher.name = this.dispatcher.email.subject;

        if (! this.constructor.hasContent(htmlContent)) {
            this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:CONTENT_EMPTY'));
            return deferred.reject();
        }

        if (this.dispatcherType == 'campaign') {
            this.campaignRepo.update(this._stateParams.dispatcherId, this.dispatcher).then((response) => {
                this.eventRepo.setEdited(this._stateParams.dispatcherId, this.dispatcherType).then(() => {
                    this.hasBeenEdited = true;
                });

                if (response.error) {
                    this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:UPDATE_ERROR'));
                    deferred.reject();
                } else {
                    this._scope.$broadcast('dispatcher:updated'); // Used for updating history.
                    this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:SAVED'));
                    deferred.resolve();
                }
            }, (error) => {
                this.handleSaveError(error.data.code);
            });
        } else if (this.dispatcherType == 'automation') {
            this.automationRepo.saveEmail(this._stateParams.dispatcherId, this.dispatcher.email).then((email) => {
                this.eventRepo.setEdited(this._stateParams.emailId, 'automation').then(() => {
                    this.hasBeenEdited = true;
                });
                
                this.dispatcher.email = email.data;

                this.eventHandler.flashEvent('notification', this._translator('AUTOMATION:FLASH:SAVED'));
                this._scope.$broadcast('dispatcher:updated');
                deferred.resolve();
            }, (error) => {
                if (error.status == 400 && error.data == 'ValidationError') { // Error handling.
                    angular.forEach(Object.keys(error.data.message), (validationError) => {
                        if (validationError == 'email.from_email') {
                            this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:FLASH:INVALID_FROM_EMAIL'));
                        } else if (validationError == 'email.subject') {
                            this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:INVALID_SUBJECT'));
                        } else if (validationError == 'email.from_name') {
                            this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:FLASH:INVALID_FROM_NAME'));
                        } else if (validationError == 'email.plain_content') {
                            this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:FLASH:EMPTY_PLAIN_CONTENT'));
                        }
                    });

                    deferred.reject();
                }
            });
        }
        
        return deferred.promise;
    };

    validSender() {
        return this.dispatcher.email.from_name.length > 0 && this.dispatcher.email.from_email
    };

    validSubject() {
        return this.dispatcher.email.subject.length > 0;
    };

    validPreview() {
        let returnArray = [];

        if (! this.preview.to) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:PREVIEW_RECIPENT_ERROR'));
        } if (! this.validSender()) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:INVALID_SENDER'));
        } if (! this.validSubject()) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:INVALID_SUBJECT'));
        } if (this.preview.to && this.preview.to.split(',').length > 30) {
            returnArray.push(this._translator('CAMPAIGN:PREVIEW:TOO_MANY_RECIPENTS'));
        }
        return returnArray
    };

    errorHandler(error) {
        if (error.status == 400) {
            this.alerter.swal({
                title: 'Error',
                text: this._translator('CAMPAIGN:FLASH:PREVIEW_RECIPENT_FORMAT_ERROR'),
                type: 'error'
            });
        } else if (error.status == 413) {
            this.alerter.swal({
                title: 'Error',
                text: this._translator('CAMPAIGN:PREVIEW:TOO_MANY_RECIPENTS'),
                type: 'error'
            });
        } else {
            this.alerter.swal({
                title: 'Error',
                text: this._translator('CAMPAIGN:FLASH:PREVIEW_ERROR'),
                type: 'error'
            });
        }
    };

    sendPreview() {
        if (this.validPreview().length > 0) {
            let message = '';

            angular.forEach(this.validPreview(), (errorMsg) => {
                message += errorMsg + '\n';
            });

            return this.alerter.swal({
                title: 'Error',
                text: message,
                type: 'error'
            });
        }

        this.save().then(() => {
            if (this._stateParams.type == 'campaign') {
                this.rest.all('campaign').all('preview').post({
                    campaign_id: this.dispatcher.id,
                    preview_to: this.preview.to,
                    email_id: this.dispatcher.email.id
                }).then(() => {
                    this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:PREVIEW'))
                }, (error) => {
                    return this.errorHandler(error);
                })
            } else {
                this.rest.all('email').all('preview').post({
                    email_id: this.dispatcher.email.id,
                    preview_to: this.preview.to
                }).then(() => {
                    this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:PREVIEW'))
                }, (error) => {
                    return this.errorHandler(error);
                })
            }
        })
    };

    toIndex() {
        if (! this.hasBeenEdited) {
            this.alerter.swal({
                title: this._translator('EVENT:FLASH:BACK_HEADER'),
                text: this._translator('EVENT:FLASH:BACK_BODY'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this._translator('GLOBAL:YES'),
                cancelButtonText: this._translator('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.save().then(() => {
                        this._state.go('event.folder', { folder: this.statusIdToNameMap[this.event.event_status_id] });
                    })
                } else {
                    this._state.go('event.folder', { folder: this.statusIdToNameMap[this.event.event_status_id] });
                }
            });
        } else {
            this._state.go('event.folder', { folder: this.statusIdToNameMap[this.event.event_status_id] });
        }
    };
};
